import React, { useState, createRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Popover } from '@material-ui/core';
import { Login } from '../Login';

const useStyles = makeStyles((theme) => ({
  popover: {
    background: '#cccccc66',
    '& .MuiPopover-paper': {
      background: 'transparent',
      'box-shadow': '0 0',
    },
  },
}));

export default function PopLogin(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(createRef());

  return (
    <div>
      <Popover
        id="simple-popover"
        className={classes.popover}
        open={true}
        ref={(el) => {
          setAnchorEl(el);
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
      >
        <Login submitClick={props.submitClick} />
      </Popover>
    </div>
  );
}
